import { render, staticRenderFns } from "./ArticleTransfer.vue?vue&type=template&id=59e1f911&scoped=true"
import script from "./ArticleTransfer.vue?vue&type=script&lang=ts"
export * from "./ArticleTransfer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59e1f911",
  null
  
)

export default component.exports